/// <amd-module name="VSS/Platform/IPlatformRestErrorHandler" />

import { IVssService, RestErrorHandlerResponse } from "./Context";

/**
 * Platform-level service called by RestClientBase when there's an error making a request. Should not be called
 * directly. Implement IRestErrorHandlerService to handle errors.
 * Keep in sync with old web platform declaration and usage in VSS/WebApi/RestClient.
 */
export interface IPlatformRestErrorHandlerService extends IVssService {
    /**
     * Wait for this before issuing a REST request.
     */
    requestsEnabled(): Promise<void>;
    handleError(
        tries: number,
        text: string | undefined,
        response: Response | XMLHttpRequest | undefined,
        error: Error
    ): Promise<RestErrorHandlerResponse>;
}

/**
 * A contributed service implementing this interface and targetting ms.vss-web.rest-error-handler-root will be called
 * when there is an exception making a REST request and offered the opportunity to handle the error.
 *
 * @param tries the number of attempts that have been made (starts at 1)
 * @param text the response text, if it has been read
 * @param response the Response from the Fetch API
 * @param error the exception that was raised
 */
export interface IRestErrorHandlerService extends IVssService {
    handleError(tries: number, text: string | undefined, response: Response | undefined, error: Error): Promise<RestErrorHandlerResponse>;
    handleOldPlatError(tries: number, text: string | undefined, xhr: XMLHttpRequest | undefined, error: Error): Promise<RestErrorHandlerResponse>;
}
